import React from 'react';
import Badge from './Badge';

/**
 * StatusPill — single source of truth for status → color mapping across the app.
 * Ensures Partners, Requests, Clients all use identical semantics.
 *
 * If a status isn't mapped, falls back to neutral with the raw status string.
 */
const STATUS_MAP = {
  // Partners
  active: { variant: 'success', label: 'Actif' },
  suspended: { variant: 'neutral', label: 'Suspendu' },
  inactive: { variant: 'danger', label: 'Inactif' },

  // Client requests
  pending: { variant: 'warning', label: 'En attente' },
  approved: { variant: 'info', label: 'Approuvé' },
  provisioning: { variant: 'info', label: 'Provisionnement', animated: true },
  rejected: { variant: 'danger', label: 'Rejeté' },

  // Clients / contracts
  expired: { variant: 'danger', label: 'Expiré' },
  expiring: { variant: 'warning', label: 'Bientôt expiré' },

  // Migrations
  idle: { variant: 'neutral', label: 'Idle' },
  running: { variant: 'info', label: 'En cours', animated: true },
  ok: { variant: 'success', label: 'OK' },
  error: { variant: 'danger', label: 'Erreur' },
};

export function StatusPill({ status, label, className, size = 'md' }) {
  const entry = STATUS_MAP[status] || { variant: 'neutral', label: label || status || '—' };
  return (
    <Badge variant={entry.variant} size={size} dot className={className}>
      {entry.animated && (
        <span
          aria-hidden
          className="h-1.5 w-1.5 -ml-1 rounded-full bg-current opacity-70 animate-ping"
        />
      )}
      {label || entry.label}
    </Badge>
  );
}

export default StatusPill;
